<template>
  <img 
    draggable="false"
    :alt="alt"
    :src="src"
    :srcset="srcset"
    :class="{
      'is-loading': !isLoaded
    }" 
  />
</template>

<script>
export default {
  data() {
    return {
      isLoaded: false
    }
  },
  props: {
    src: {
      type: String
    },
    srcset: {
      type: String
    },
    alt: {
      type: String
    },
  },
  created() {
    this.loadImage()
  },
  methods: {
    loadImage() {
      const img = new Image()
      img.onload = ()=> {
        this.isLoaded = true
      }
      img.src = this.src
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  transition: 250ms opacity;
}

img.is-loading {
  opacity: 0;
}

</style>